import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"
import { IconStar, IconStarFilled } from "@tabler/icons-react"

interface StarRatingProps {
  value: number | undefined
  onChange: (rating: number) => void
  maxStars?: number
  className?: string
}

export function StarRating({
  value,
  onChange,
  maxStars = 5,
  className,
}: StarRatingProps) {
  const { translate } = useTranslation()
  return (
    <div className={cn("flex gap-1", className)}>
      {Array.from({ length: maxStars }, (_, index) => {
        const starValue = index + 1
        const isFilled = value !== undefined && starValue <= value

        return (
          <button
            key={starValue}
            type="button"
            onClick={() => onChange(starValue)}
            className="rounded p-0.5 transition-colors hover:text-yellow1 focus:outline-hidden focus:ring-2 focus:ring-yellow1 focus:ring-offset-2"
            aria-label={translate("FEEDBACK_SUBMISSION/RATE_ARIA_LABEL", {
              starValue,
              maxStars,
            })}
          >
            {isFilled ? (
              <IconStarFilled className="h-6 w-6 text-yellow1" />
            ) : (
              <IconStar className="h-6 w-6 text-muted-foreground hover:text-yellow1/70" />
            )}
          </button>
        )
      })}
    </div>
  )
}
